import React from 'react';
import { useNavigate } from 'react-router-dom';
import * as B from './Modal.styles';
import ModalImg from 'assets/MainImage/ModalImage.png';

interface Reservation {
  id: number;
  startTime: string;
  durationMinutes: number;
  headCount: number;
  facility: {
    id: number;
    name: string;
    description: string;
    purpose: string;
    equipment: string;
    caution: string;
    location: string;
    imageUrl: string;
  };
  member: {
    name: string;
    profileImage: string | null;
    universityId: number;
  };
}

interface ReturnModalProps {
  isOpen: boolean;
  onClose: () => void;
  reservation: Reservation;
}

const ReturnModal: React.FC<ReturnModalProps> = ({
  isOpen,
  onClose,
  reservation
}) => {
  const navigate = useNavigate();

  const formatDate = (isoString: string): string => {
    const date = new Date(isoString);
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const formatTime = (isoString: string): string => {
    const date = new Date(isoString);
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    return `${hours}:${minutes}`;
  };

  const calculateEndTime = (startTime: string, durationMinutes: number): string => {
    const start = new Date(startTime);
    const end = new Date(start.getTime() + durationMinutes * 60 * 1000);
    const hours = end.getHours().toString().padStart(2, '0');
    const minutes = end.getMinutes().toString().padStart(2, '0');
    return `${hours}:${minutes}`;
  };

  const handleModalClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      handleClose();
    }
  };

  const handleStatusBottomClick = () => {
    navigate(`/reviews/create/${reservation.id}`);
    onClose();
  };

  const handleClose = () => {
    navigate('/home');
    onClose();
  };

  if (!isOpen) {
    return null;
  }

  const date = formatDate(reservation.startTime);
  const startTime = formatTime(reservation.startTime);
  const endTime = calculateEndTime(reservation.startTime, reservation.durationMinutes);

  return (
    <B.ModalOverlay onClick={handleModalClick}>
      <B.ModalTotal>
        <B.ModalHeader>
          {reservation.member.name}님의 {'<'}<B.GreenText>{reservation.facility.name}</B.GreenText>{'>'} <br />
          반납이 완료되었습니다.
        </B.ModalHeader>
        <B.ModalContent>
          <button className="close-btn" onClick={handleClose}>&times;</button>
          <img className="img" src={reservation.facility.imageUrl || ModalImg} alt={reservation.facility.name} />
          <B.ModalInfo>
            <div className="title">{reservation.facility.name}</div>
            <div className="location">{reservation.facility.location}</div>
            <div className="time">
              이용일 {date}<br />
              이용시간 {startTime}~{endTime}
            </div>
          </B.ModalInfo>
          <B.Button>
            <button className="button" onClick={handleStatusBottomClick}>리뷰 작성하기</button>
          </B.Button>
        </B.ModalContent>
      </B.ModalTotal>
    </B.ModalOverlay>
  );
};

export default ReturnModal;
